import { render, staticRenderFns } from "./CellRendererCustomerStatus.vue?vue&type=template&id=ccd59a54&scoped=true"
import script from "./CellRendererCustomerStatus.vue?vue&type=script&lang=js"
export * from "./CellRendererCustomerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd59a54",
  null
  
)

export default component.exports